export const withHttp = url => {
  const stripUrl = url.replace(/ /g, '')
  const newUrl = !/^https?:\/\//i.test(stripUrl)
    ? `http://${stripUrl}`
    : stripUrl
  return newUrl
}
